import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "remote-filters-chips tw-flex tw-flex-wrap tw-items-start",
  "data-test": "active-filter-section"
}
const _hoisted_2 = { class: "remote-filters-chips__chip tw-bg-core-primary-99 tw-flex tw-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "tw-pr-1 tw-pl-2 body--auxiliary-01 tw-text-core-primary-10"
}
const _hoisted_4 = { class: "tw-flex tw-items-center tw-h-10" }

import CoreChipAction from 'frontcore/views/chips/chip/views/CoreChipAction.vue'
import CoreChipInput from 'frontcore/views/chips/chip/views/CoreChipInput.vue'
import i18n from 'frontcore/i18n'
import useRemoteFiltersStore from 'frontcore/presentation/remote-filters/data/use-remote-filters-store'
import { computed } from 'vue'
import {
  RemoteFiltersBooleanValue,
  RemoteFiltersDateRangeValue,
  RemoteFiltersDateValue,
  RemoteFiltersOptionListValue,
  RemoteFiltersOptionValue,
  RemoteFiltersValue,
} from 'frontcore/presentation/remote-filters/domain/remote-filters-value'
import {
  RemoteFiltersChip,
  RemoteFiltersFieldType,
} from 'frontcore/presentation/remote-filters/domain/types'

type Props = {
  filterStoreID: string
}
type Emits = (e: 'selectFilterItem') => void

export default /*@__PURE__*/_defineComponent({
  __name: 'RemoteFiltersSelectedChips',
  props: {
    filterStoreID: {}
  },
  emits: ["selectFilterItem"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const filtersStore = computed(() => {
  return useRemoteFiltersStore(props.filterStoreID)
})

const { t } = i18n.global

const wrapperStyleClass = (chip: RemoteFiltersChip, chips: RemoteFiltersChip[]): string[] => {
  const styleClass: string[] = ['tw-flex tw-items-center tw-h-10', 'tw-flex-none']
  if (chip.id === chips.at(0)?.id) {
    styleClass.push('remote-filters-chips__wrapper--first')
  }
  if (chip.id === chips.at(-1)?.id) {
    styleClass.push('tw-mr-2')
  }
  return styleClass
}

const isTitleVisible = (chip: RemoteFiltersChip, index: number): boolean => {
  return (chip.filterType !== RemoteFiltersFieldType.SWITCH && chip.filterType !== RemoteFiltersFieldType.SEGMENTED_BUTTON) && index === 0
}

const hasChanges = computed(() => {
  return Object.values(filtersStore.value.stagedFilters)
    .some((filter: RemoteFiltersValue) => filtersStore.value.isFilterChanged(filter.configuration))
})

const onSelectFilterItem = (): void => {
  emit('selectFilterItem')
}

const onDeleteFilterItem = (chip: RemoteFiltersChip) => {
  const remoteFiltersValue = filtersStore.value.getRemoteFiltersValue(chip.filterId)
  if (remoteFiltersValue === undefined) { return }
  if (remoteFiltersValue instanceof RemoteFiltersBooleanValue) {
    remoteFiltersValue.value = false
  } else if (remoteFiltersValue instanceof RemoteFiltersDateRangeValue) {
    remoteFiltersValue.value = []
  } else if (remoteFiltersValue instanceof RemoteFiltersDateValue) {
    remoteFiltersValue.value = undefined
  } else if (remoteFiltersValue instanceof RemoteFiltersOptionListValue) {
    remoteFiltersValue.value = remoteFiltersValue.value.filter((rfv) => rfv !== chip.id)
  } else if (remoteFiltersValue instanceof RemoteFiltersOptionValue) {
    remoteFiltersValue.value = undefined
  }
  filtersStore.value.commitChanges()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtersStore.value.remoteFiltersChips, (chips, title) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chips, (chip, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${chip.filterId}.${chip.id}`,
            class: _normalizeClass(wrapperStyleClass(chip, chips))
          }, [
            _createElementVNode("div", _hoisted_2, [
              (isTitleVisible(chip, index))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(title), 1))
                : _createCommentVNode("", true),
              _createVNode(CoreChipInput, {
                dataTest: `remote-filters-chip-${chip.filterId}-${chip.id}`,
                deletable: !chip.required,
                label: chip.text,
                selected: "",
                onClick: onSelectFilterItem,
                onHandlerClick: () => onDeleteFilterItem(chip)
              }, null, 8, ["dataTest", "deletable", "label", "onHandlerClick"])
            ])
          ], 2))
        }), 128))
      ], 64))
    }), 256)),
    _createElementVNode("div", _hoisted_4, [
      (hasChanges.value)
        ? (_openBlock(), _createBlock(CoreChipAction, {
            key: 0,
            dataTest: "reset-filters-button",
            class: "remote-filters-chips__reset tw-flex-none",
            iconName: "RefreshFill",
            label: _unref(t)('common.messages.reset'),
            onClick: filtersStore.value.clearChanges
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})